import React, {
 useContext, useEffect, useState, useRef, 
} from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select'; 
import { Form, InputGroup } from 'react-bootstrap';
import { Button, ButtonGroup } from '@/shared/components/Button';
import { FaExclamationCircle } from 'react-icons/fa';
import Pagination from 'react-bootstrap/Pagination';
import { ShimmerContentBlock } from 'react-shimmer-effects';
import PendingCard from './PendingCard';
import Loading from '../../../../../shared/components/Loading';
import { GlobalContext } from '../../../../../context/GlobalContext';
import ProgressBar from '../../../Loader';
import { SideBarRefreshContext } from '../../../../../context/SideBarRefreshContext';
import { AuthContext } from '../../../../../context/AuthContext';

const Pending = ({ agentId, setPaymentRefresh, paymentRefresh }) => {
  const { apiGlobal } = useContext(GlobalContext);
  const [bookingData, setBookingData] = useState([]);
  const [filteredBookingData, setFilteredBookingData] = useState([]);
  const [paxDetailsHandler, setPaxDetailsHandler] = useState([]);
  const [selectedTrip, setSelectedTrip] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [tripOption, setTripOption] = useState([]);
  const { sideBarRefresh } = useContext(SideBarRefreshContext);
  const { countryId } = useContext(AuthContext);

  // Search filter states
  const [searchTripName, setSearchTripName] = useState('');
  const [searchStartDate, setSearchStartDate] = useState('');
  const [searchEndDate, setSearchEndDate] = useState('');
  const [showAddModal, setShowAddModal] = useState(false);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 2;

  const isMounted = useRef(true);

  const fetchBookingData = async () => {
    const formData = new FormData();
    formData.append('agent_id', agentId);
    formData.append('country_id', countryId);
    try {
      // Fetch new data from API if no valid cache
      const url = await fetch(`${apiGlobal}/agent/booking_data.php`, {
        method: 'POST',
        body: formData,
      });
      const response = await url.json();
  
      if (response?.status && response?.message) {
        if (isMounted.current) {
          setBookingData(response?.data);
          setFilteredBookingData(response?.data); // Initial setting of filtered data
          const tripOptions = response?.data?.map(trip => ({
            value: trip?.id,
            label: `${trip?.name} (${trip?.trip_uin})`, 
          }));
          setTripOption(tripOptions);
          setIsLoading(false);
        }
      } else if (isMounted.current) {
        setBookingData([]);
        setIsLoading(false);
      }
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };
  

  useEffect(() => {
    isMounted.current = true;
    fetchBookingData();
    return () => {
      isMounted.current = false;
    };
  }, [agentId, refresh, sideBarRefresh?.agentBookingRefresh]); // Re-run fetch if agentId or refresh changes

  const filterBookingHandler = (selectedOption) => {
    setSelectedTrip(selectedOption); // Update selected trip

    if (!selectedOption) {
      setFilteredBookingData(bookingData); // Reset filter when no trip is selected
      setCurrentPage(1); // Reset to the first page when filtering
      return;
    }

    // Filter booking data based on selected trip ID
    const filteredData = bookingData.filter(trip => trip?.id === selectedOption?.value);
    setFilteredBookingData(filteredData);
    setCurrentPage(1); // Reset to the first page when filtering
  };

  // Pagination logic
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Slice data for the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredBookingData.slice(indexOfFirstItem, indexOfLastItem);

  // Total pages
  const totalPages = Math.ceil(filteredBookingData.length / itemsPerPage);

  // Filter Data Based on Date Range
  useEffect(() => {
    let filteredData = [...bookingData];

    if (searchStartDate) {
      filteredData = filteredData.filter((trip) => {
        const tripStartDate = new Date(trip?.start_date);
        return tripStartDate >= new Date(searchStartDate);
      });
    }

    if (searchEndDate) {
      filteredData = filteredData.filter((trip) => {
        const tripEndDate = new Date(trip?.end_date);
        return tripEndDate <= new Date(searchEndDate);
      });
    }

    setFilteredBookingData(filteredData);
  }, [searchStartDate, searchEndDate, bookingData]);


   // use Effect to add keyframes for the pulse animation
   useEffect(() => {
    // Add keyframes via JavaScript when component mounts
    const style = document.createElement('style');
    style.innerHTML = `
      @keyframes pulse {
        0% { transform: scale(1); opacity: 1; }
        50% { transform: scale(1.2); opacity: 0.8; }
        100% { transform: scale(1); opacity: 1; }
      }
    `;
    document.head.appendChild(style);
  }, []);


   if (isLoading) {
      return (
        <div>
          <ProgressBar />
        </div>
      );
    }

  return (
    <div>
      {/* <Select
        name="tripName"
        className="react-select w-25 mb-4"
        classNamePrefix="react-select"
        options={bookingData.map(trip => ({
          value: trip.id,
          label: `${trip.name} (${trip.trip_uin})`,
        }))}
        isClearable
        value={selectedTrip}
        placeholder="Select a trip"
        onChange={filterBookingHandler}
      /> */}
      {/* Search Filters */}
      <div
        className="mb-4"
        style={{
          padding: '15px',
          borderRadius: '8px',
          backgroundColor: '#f8f9fa',
          display: 'flex',
          
          justifyContent: 'flex-start',
          gap: '10px',
          alignItems: 'center',
          flexWrap: 'wrap',
        }}
      >
        <Select
          name="tripName"
          className="react-select w-25 mb-4 mt-3"
          classNamePrefix="react-select"
          options={tripOption}
          isClearable
          value={selectedTrip}
          placeholder="Select a trip"
          onChange={filterBookingHandler}
        />
        <ButtonGroup icons dir="ltr" className="mt-2">
          <Button
            variant="outline-secondary"
            className=""
            title="Refresh"
            size="sm"
            onClick={() => setRefresh(prev => !prev)}
          >
            <span className="lnr lnr-sync text-primary" />
          </Button>
        </ButtonGroup>
        {/* Search Filters */}
        <InputGroup className="mb-2" style={{ maxWidth: '160px' }}>
          <Form.Control
            type="date"
            placeholder="Start Date"
            value={searchStartDate}
            onChange={e => setSearchStartDate(e.target.value)}
            style={{
              borderRadius: '25px',
              padding: '8px',
              border: '1px solid #ddd',
            }}
          />
        </InputGroup>

        <InputGroup className="mb-2" style={{ maxWidth: '160px' }}>
          <Form.Control
            type="date"
            placeholder="End Date"
            value={searchEndDate}
            onChange={e => setSearchEndDate(e.target.value)}
            style={{
              borderRadius: '25px',
              padding: '8px',
              border: '1px solid #ddd',
            }}
          />
        </InputGroup>

        <Button
          variant="outline-danger"
          style={{
            borderRadius: '25px',
            padding: '8px 16px',
            marginLeft: '10px',
            alignSelf: 'center',
          }}
          className="mt-3"
          onClick={() => {
            setSearchStartDate('');
            setSearchEndDate('');
          }}
        >
          Clear Filters
        </Button>
      </div>
      <div>
        {currentItems.length > 0 ? (
          currentItems.map(booking => (
            <PendingCard 
              key={booking?.id}
              bookingData={booking}
              setRefresh={setRefresh}
              paxDetailsHandler={paxDetailsHandler}
              setPaxDetailsHandler={setPaxDetailsHandler}
            />
          ))
        ) : (
          <div style={{
            textAlign: 'center',
            padding: '50px',
            backgroundColor: '#f8d7da',
            borderRadius: '8px',
            marginTop: '20px',
            color: '#721c24',
            fontSize: '16px',
            }}
          >
            <div
              style={{
              fontSize: '48px',
              marginBottom: '20px',
              color: '#e63946',
              animation: 'pulse 1.5s infinite ease-in-out',
              display: 'inline-block',
              }}
            >
              <FaExclamationCircle style={{ fontSize: '48px', marginBottom: '20px' }} />
            </div>
            <p>No Pending booking available</p>
          </div>
        )}
      </div>

      {/* Pagination Controls */}
      <div style={{
       float: 'right',
       bottom: '20px', 
       right: '20px', 
       zIndex: 999, 
       display: 'flex', 
       justifyContent: 'center', 
       alignItems: 'center', 
      }}
      >
        <Pagination>
          <Pagination.Prev
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          />
          {Array.from({ length: totalPages }, (_, index) => (
            <Pagination.Item
              key={index + 1}
              active={index + 1 === currentPage}
              onClick={() => handlePageChange(index + 1)}
            >
              {index + 1}
            </Pagination.Item>
          ))}
          <Pagination.Next
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          />
        </Pagination>
      </div>
    </div>
  );
};

Pending.propTypes = {
  agentId: PropTypes.string.isRequired,
  setPaymentRefresh: PropTypes.func.isRequired,
  paymentRefresh: PropTypes.bool.isRequired,
};

export default Pending;
